import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-gradiant-button",
  templateUrl: "./gradiant-button.component.html",
  styleUrls: ["./gradiant-button.component.scss"],
  standalone: false,
})
export class GradiantButtonComponent implements OnInit {
  @Input() text: string = "DEVENIR TRANSPORTEUR";
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();
  constructor() {}

  ngOnInit() {}
  click() {
    this.onClick.emit();
  }
}
